import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { Formik, Field } from "formik";
import { useParams } from "react-router-dom";
import { required, passwordRegex } from "../../../utils/validations";

function ManageStaffRegisterForm(props) {
    const { id } = useParams();
    return (
        < div >
            <Formik
                initialValues={props.initialValues}
                validate={(values) => {
                    let errors = {};
                    if (!values.password && !id) {
                        errors.password = required(values.password);
                    }
                    if (!values.confirmPassword && !id) {
                        errors.confirmPassword = required(values.confirmPassword);
                    }
                    if (passwordRegex(values.password)) {
                        errors.password = passwordRegex(values.password)
                    }
                    if (values.password != values.confirmPassword) {
                        errors.confirmPassword = "Password and Confirm Password does not match"
                    }
                    return errors;
                }}
                enableReinitialize={true}
                onSubmit={(values) => {
                    props.submit(values);
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                }) => {
                    return (
                        <>
                            <Form onSubmit={handleSubmit}>
                                <div className={"manageplan"}>
                                    <div>
                                        <div className={"basic_details"}>
                                            <div className={"examfilter"}>
                                                <h4 className={"examfilter_heading"}>
                                                    Manage Staff Register
                                                </h4>
                                                <Row>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3" controlId="title">
                                                            <Form.Label>Email</Form.Label>
                                                            <Select
                                                                className="basic-single"
                                                                placeholder="Email..."
                                                                name="email"
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                getOptionLabel={(option) => option?.email}
                                                                getOptionValue={(option) => option?.id}
                                                                value={id ? props.listData : values?.email}
                                                                // onBlur={handleBlur} error on touched but not filled field
                                                                onChange={(obj) => {
                                                                    setFieldValue("email", obj)
                                                                }}
                                                                onInputChange={(e)=>{
                                                                    props.searchUser(e)
                                                                }}
                                                                isDisabled={id ? true : false}
                                                                options={props?.fieldData?.users}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group className="mb-3" controlId="name">
                                                            <Form.Label>Enter Password</Form.Label>
                                                            <Form.Control
                                                                type="password"
                                                                name="password"
                                                                placeholder="Password"
                                                                className={"input_pd"}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values?.password}
                                                            />
                                                            {errors.password && touched.password && (
                                                                <div className="error">{errors.password}</div>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group className="mb-3" controlId="name">
                                                            <Form.Label>Confirm Password</Form.Label>
                                                            <Form.Control
                                                                type="password"
                                                                name="confirmPassword"
                                                                placeholder="Confirm Password"
                                                                className={"input_pd"}
                                                                onChange={(e) => {
                                                                    setFieldValue("confirmPassword", e.target.value)
                                                                }}
                                                                onBlur={handleBlur}
                                                                value={values?.confirmPassword}
                                                            />
                                                            {errors.confirmPassword && touched.confirmPassword && (
                                                                <div className="error">{errors.confirmPassword}</div>
                                                            )}
                                                        </Form.Group>
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3" controlId="title">
                                                            <Form.Label>Group</Form.Label>
                                                            <Select
                                                                className="basic-single"
                                                                placeholder="Group..."
                                                                name="group"
                                                                isMulti
                                                                isClearable={true}
                                                                getOptionLabel={(option) => option.value}
                                                                getOptionValue={(option) => option.id}
                                                                onChange={(obj) => {
                                                                    setFieldValue("group", obj)
                                                                }}
                                                                value={values?.group}
                                                                options={props?.fieldData?.groups}
                                                            />
                                                        </Form.Group>
                                                    </Col>


                                                </Row>
                                                <Row>
                                                    <Col sm={4}>
                                                        <Form.Group className="mt-4" controlId="online">
                                                            <Field
                                                                type="checkbox"
                                                                name="is_active"
                                                                className={"mode_checkbox"}
                                                                component={Form.Check}
                                                                checked={values?.is_active}
                                                                onChange={(e) =>
                                                                    setFieldValue("is_active", !values?.is_active)
                                                                }
                                                            />{" "}
                                                            <Form.Label>Is Active</Form.Label>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className={"formBtnBottom mt-2"}>
                                                        <Form.Group>
                                                            <button
                                                                className={"btnInfo"}
                                                                type="submit"
                                                            >
                                                                Submit
                                                            </button>
                                                            <button
                                                                className={"btnInfo"}
                                                                type="reset"
                                                                onClick={() => props.onCancel()}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                        <Row></Row>

                                    </div>
                                </div>
                            </Form>
                        </>
                    )
                }}
            </Formik>
        </div >
    )
}

export default ManageStaffRegisterForm;